import { render, staticRenderFns } from "./ServerFilterModeValueBadge.vue?vue&type=template&id=03ce3401&scoped=true&"
import script from "./ServerFilterModeValueBadge.vue?vue&type=script&lang=js&"
export * from "./ServerFilterModeValueBadge.vue?vue&type=script&lang=js&"
import style0 from "./ServerFilterModeValueBadge.vue?vue&type=style&index=0&id=03ce3401&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ce3401",
  null
  
)

export default component.exports
import {QBadge} from 'quasar'
component.options.components = Object.assign({QBadge}, component.options.components || {})
